import React from 'react';
import './footer.css'; 

export const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2023 Your Website Name. All Rights Reserved.</p>
    </footer>
  );
};

